import React, { useState, useEffect } from "react"
import dayjs from "dayjs"
import "../../Styles/Reservation.css"
import { Link } from "react-router-dom"
import UseallOverview from "../Componentslogic/UseAlloverview"

const DeliveryPage = () => {
  const getStoredDate = (key, defaultValue) => {
    return localStorage.getItem(key) || defaultValue
  }

  const [startDate, setStartDate] = useState(
    getStoredDate("startDate", dayjs().format("YYYY-MM-DD"))
  )
  const [endDate, setEndDate] = useState(
    getStoredDate("endDate", dayjs().format("YYYY-MM-DD"))
  )

  useEffect(() => {
    // Save selected dates to local storage
    localStorage.setItem("startDate", startDate)
    localStorage.setItem("endDate", endDate)
  }, [startDate, endDate])

  const [selectedFilter, setSelectedFilter] = useState("All")
  const [searchQuery, setSearchQuery] = useState("")

  const {
    data: deliveryData,
    loading,
    hasMore,
    nextPage,
  } = UseallOverview("Orders", startDate, endDate)

  const getStatus = (order) => {
    if (order.Done) return { text: "Done", className: "Delivered" }
    if (order.Confirmed) return { text: "Confirmed", className: "fulfilled" }
    if (!order.Confirmed) return { text: "Placed", className: "pending" }
    return { text: "Unknown", className: "Unknown" }
  }

  const handleFilterClick = (filter) => {
    setSelectedFilter(filter)
  }

  const filteredData = deliveryData.filter((order) => {
    const { text } = getStatus(order)

    const matchesSearch =
      !searchQuery || order.ordernumber === Number(searchQuery)
    const matchesFilter = selectedFilter === "All" || text === selectedFilter

    return matchesSearch && matchesFilter
  })

  const handleInputClick = (e) => {
    e.preventDefault()
    e.target.showPicker()
  }

  return (
    <div className="dashboard-container">
      <main className="main-content">
        {/* Date Filters */}
        <div className="d-flex justify-content-center mb-3">
          <div className="d-flex flex-column align-items-center mx-3">
            <label htmlFor="start-date" className="mb-2">
              Start Date
            </label>
            <input
              id="start-date"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              onClick={handleInputClick}
              className="date-picker"
            />
          </div>
          <div className="d-flex flex-column align-items-center">
            <label htmlFor="end-date" className="mb-2">
              End Date
            </label>
            <input
              id="end-date"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              onClick={handleInputClick}
              className="date-picker"
            />
          </div>
        </div>

        {/* Search and Filter Section */}
        <header className="header">
          <input
            type="text"
            placeholder="Search by order number..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-box"
          />
        </header>

        <section className="summary-cards">
          <div
            className={`card ${
              selectedFilter === "All" ? "active-filter" : ""
            }`}
            onClick={() => handleFilterClick("All")}
          >
            All Orders
          </div>

          <div
            className={`card ${
              selectedFilter === "Placed" ? "active-filter" : ""
            }`}
            onClick={() => handleFilterClick("Placed")}
          >
            Placed
          </div>
          <div
            className={`card ${
              selectedFilter === "Confirmed" ? "active-filter" : ""
            }`}
            onClick={() => handleFilterClick("Confirmed")}
          >
            Confirmed
          </div>
          <div
            className={`card ${
              selectedFilter === "Done" ? "active-filter" : ""
            }`}
            onClick={() => handleFilterClick("Done")}
          >
            Done
          </div>
        </section>

        {/* Orders Table */}
        <section className="orders-table">
          <table>
            <thead>
              <tr>
                <th>Order</th>
                <th>Ordered At</th>

                <th>Customer</th>
                <th>Total</th>
                <th>Status</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((order, index) => {
                // Safely handle Firebase timestamps
                const orderDate =
                  order.createdAt && order.createdAt.toDate
                    ? order.createdAt.toDate()
                    : new Date(order.createdAt) // Use .toDate() for Firebase Timestamp

                const updatedDate =
                  order.updatedAt && order.updatedAt.toDate
                    ? order.updatedAt.toDate()
                    : new Date(order.updatedAt)

                // Extract time
                const orderTime = orderDate.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })

                const updatedTime = updatedDate.toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })
                const { text, className } = getStatus(order)
                return (
                  <tr key={index}>
                    <td>{order.ordernumber}</td>
                    <td>{orderTime}</td>

                    <td>{order.userName}</td>
                    <td>{order.totalAmount.toFixed(2)} EGP</td>
                    <td>
                      <span className={`status ${className}`}>{text}</span>
                    </td>

                    <td>
                      <Link to={`/adminorderdetails/${order.id}`}>
                        <button className="btns-Admin">View</button>
                      </Link>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </section>

        {/* Pagination */}
        {loading && <p>Loading...</p>}

        {hasMore && !loading && (
          <div className="d-flex justify-content-center align-items-center">
            <button className="btn-Load" onClick={() => nextPage()}>
              Load More
            </button>
          </div>
        )}
      </main>
    </div>
  )
}

export default DeliveryPage
